module.exports = __webpack_public_path__ + "static/leadership-e737ab2161e9a3ffa7fe94588bc540d3.png";